var _rect, _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.02295,
    width: 27.17,
    height: 27.1826,
    rx: 13.585,
    fill: "#123164",
    stroke: "#123164",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_110_3238",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0275 18.3934L13.1849 14.5404L17.0275 10.6875L15.8445 9.50391L10.8105 14.5404L15.8445 19.5769L17.0275 18.3934Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0275 18.3934L18.4421 19.8072C19.2221 19.0269 19.2228 17.7623 18.4436 16.981L17.0275 18.3934ZM13.1849 14.5404L11.7688 13.1281C10.9903 13.9087 10.9903 15.1721 11.7688 15.9527L13.1849 14.5404ZM17.0275 10.6875L18.4436 12.0998C19.2228 11.3186 19.2221 10.054 18.4421 9.27363L17.0275 10.6875ZM15.8445 9.50391L17.2591 8.09005C16.884 7.71476 16.3752 7.50391 15.8445 7.50391C15.3139 7.50391 14.8051 7.71476 14.43 8.09005L15.8445 9.50391ZM10.8105 14.5404L9.39598 13.1266C8.6154 13.9075 8.6154 15.1733 9.39598 15.9543L10.8105 14.5404ZM15.8445 19.5769L14.43 20.9908C14.8051 21.3661 15.3139 21.5769 15.8445 21.5769C16.3752 21.5769 16.884 21.3661 17.2591 20.9908L15.8445 19.5769ZM18.4436 16.981L14.601 13.1281L11.7688 15.9527L15.6114 19.8057L18.4436 16.981ZM14.601 15.9527L18.4436 12.0998L15.6114 9.27517L11.7688 13.1281L14.601 15.9527ZM18.4421 9.27363L17.2591 8.09005L14.43 10.9178L15.613 12.1013L18.4421 9.27363ZM14.43 8.09005L9.39598 13.1266L12.2251 15.9543L17.2591 10.9178L14.43 8.09005ZM9.39598 15.9543L14.43 20.9908L17.2591 18.1631L12.2251 13.1266L9.39598 15.9543ZM17.2591 20.9908L18.4421 19.8072L15.613 16.9795L14.43 18.1631L17.2591 20.9908Z",
    fill: "white",
    mask: "url(#path-2-inside-1_110_3238)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.232c38a0da59c0048efd5eadcfd5ed0a.svg";
export { ForwardRef as ReactComponent };